module.exports = __webpack_public_path__ + "static/media/Checked.44640313.svg";